module.exports = __webpack_public_path__ + "img/honda-Worth.13929e3f.png";